import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import PATHS from '~/app/utils/paths';
import loadable from '@loadable/component';
import SideBarLayout from '../layouts/SideBarLayout';

// AE-specific page components (to be created in /pages/ae/)
const MyVehicleCollectionAE = loadable(() => import(/* webpackChunkName: "MyVehicleCollectionAE" */ '~/app/pages/ae/MyVehicleCollection'));
const MyAccountPageAE = loadable(() => import(/* webpackChunkName: "MyAccountPageAE" */ '~/app/pages/ae/NewAccountPage'));
const FXPreorderDetailsPageAE = loadable(() => import(/* webpackChunkName: "FXPreorderDetailsPageAE" */ '~/app/pages/ae/FXPreorderDetailsPage'));
// const FXPointsAE = loadable(() => import(/* webpackChunkName: "FXPointsAE" */ '~/app/pages/ae/FXPoints'));
// const FXReferrerProgramAE = loadable(() => import(/* webpackChunkName: "FXReferrerProgramAE" */ '~/app/pages/ae/FXReferralProgram'));

const AEMyFFRouter = () => (
  <SideBarLayout>
    <Switch>
      <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.MY_FF}`} component={MyVehicleCollectionAE} />
      <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.MY_ACCOUNT}`} component={MyAccountPageAE} />
      <Route path={`/:locale(ae_ar|ae_en)${PATHS.FX_PREORDER_DETAILS}`} component={FXPreorderDetailsPageAE} />      
      {/* <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.MY_FX_REFERRALS}`} component={FXReferrerProgramAE} /> */}      
      {/* <Route exact path={`/:locale(ae_ar|ae_en)${PATHS.MY_FX_POINTS}`} component={FXPointsAE} /> */}

      <Redirect to="/:locale(ae_ar|ae_en)/404" />
    </Switch>
  </SideBarLayout>
);

export default AEMyFFRouter;
